import { constants, typographyStyles } from "@newsela/angelou";

const { textSObj } = typographyStyles;

const uiColors = constants.colors.ui;

export const rootCss = {
  paddingTop: "4px",
};

export const noCommentErrorMessageCss = {
  display: "flex",
};

export const noCommentErrorSvgCss = {
  width: "18px",

  "path:first-of-type": {
    fill: uiColors.red[600],
    stroke: uiColors.red[600],
  },

  "path:last-of-type": {
    strokeWidth: 3,
  },
};

export const noCommentErrorTextCss = {
  ...textSObj,
  color: uiColors.red[600],
  marginLeft: "3px",
};
